import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractPeriodColumn from "./AbstractPeriodColumn.js";

/**
 * Rolling period column template.
 *
 * Display the accumulated value rolling back N months (default to 12).
 *
 * @param {number} [spec.numberOfMonths] - Number of months to accumulate.
 */
class RollingPeriodColumn extends AbstractPeriodColumn {
	constructor({ numberOfMonths = 12 }) {
		super(...arguments);
		this._numberOfMonths = numberOfMonths;
	}

	getNumberOfMonths() {
		return this._numberOfMonths;
	}

	accept(visitor) {
		return visitor.visitRollingPeriodColumn(this);
	}

	_getDefaultTitle() {
		return _("R-{numberOfMonths} {period}", {
			numberOfMonths: this._numberOfMonths,
			period: super._getDefaultTitle(),
		});
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.numberOfMonths = this._numberOfMonths;

		return properties;
	}

	static getType() {
		return "RollingPeriodColumn";
	}
}

export default RollingPeriodColumn;
